import React, { Suspense,lazy } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import NotFound from './routing/NotFound';

import Home from './routing/Home';
import Dashboard from './routing/Dashboard';

import LoginPage from './routing/LoginPage';
import RegisterIntervenantPage from './routing/RegisterIntervenantPage';

import SiteList from './routing/SiteList';
import SiteDetails from './routing/SiteDetails';
import SiteCreatePage from './routing/SiteCreatePage';

import DeclarationList from './routing/DeclarationList';
import DeclarationDetails from './routing/DeclarationDetails';
import DeclarationCreatePage from './routing/DeclarationCreatePage';

import DommageList from './routing/DommageList';
import DommageDetails from './routing/DommageDetails';
import DommageCreatePage from './routing/DommageCreatePage';

import IntervenantList from './routing/IntervenantList';
import IntervenantDetails from './routing/IntervenantDetails';

import InvitationsDeclarations from './components/InvitationsDeclarations';

import Profile from './routing/Profile';

import Agenda from './routing/Agenda';

import StatPage from './routing/StatPage';

//const StatPage = lazy(() => import('./routing/StatPage'));
//const Agenda = lazy(() => import('./routing/Agenda'));


function App() {

    return (
            <Routes>
                <Route path="/login" element={<LoginPage />} />

                {/* <Route path="/register" element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <RegisterPage />} /> */}
                <Route path="/invite/intervenant/:inviteToken" element={<RegisterIntervenantPage />} />
                {/* <Route path="/register/client" element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <RegisterClientPage />} /> */}

                {/* Public Routes */}
                <Route path="/" element={<Home />} />

                <Route element={<Layout />}>

                    {/* Routes publiques */}
                    <Route path="*" element={<NotFound />} />

                    {/* Routes Visiteurs */}

                    <Route path="/invitations" element={<PrivateRoute component={InvitationsDeclarations} roles={['visiteur', 'admin']} />} />

                    {/* Routes privées */}
                    <Route path="/dashboard" element={<PrivateRoute component={Dashboard} />} />

                    <Route path="/profile" element={<PrivateRoute component={Profile} />} />

                    <Route path="/agenda" element={<PrivateRoute component={Agenda} />} />

                    <Route path="/sites" element={<PrivateRoute component={SiteList} roles={['admin']} />} />
                    <Route path="/sites/:uuid" element={<PrivateRoute component={SiteDetails} roles={['admin']} />} />
                    <Route path="/sites/create" element={<PrivateRoute component={SiteCreatePage} roles={['admin']} />} />

                    <Route path="/declarations" element={<PrivateRoute component={DeclarationList} roles={['admin']} />} />
                    <Route path="/declarations/:uuid" element={<PrivateRoute component={DeclarationDetails} />} />
                    <Route path="/declarations/create" element={<PrivateRoute component={DeclarationCreatePage} roles={['admin']}/>} />

                    <Route path="/dommages" element={<PrivateRoute component={DommageList} roles={['admin']} />} />
                    <Route path="/dommages/:uuid" element={<PrivateRoute component={DommageDetails} roles={['admin']} />} />
                    <Route path="/dommages/create" element={<PrivateRoute component={DommageCreatePage} roles={['admin']} />} />

                    <Route path="/intervenants" element={<PrivateRoute component={IntervenantList} roles={['admin']} />} />
                    <Route path="/intervenants/:uuid" element={<PrivateRoute component={IntervenantDetails} roles={['admin']} />} />

                    <Route path="/statistiques" element={<PrivateRoute component={StatPage} roles={['admin']} />} />
                </Route>


            </Routes>
    );
}

export default App;
